import * as AgGrid from "ag-grid-community";
import * as columns from "grid/columns";
import * as datasource from "grid/datasource";
import * as events from "utils/events";
import * as gridUtils from "grid/utils";
import * as http from "utils/http";
import { GridController } from "grid/grid_controller";

interface MadeBatch {
  amount: number;
  alfa_transmission_at?: string;
  count: number;
  created_at: string;
  number: number;
  payments_path: string;
  reviewer_id: number;
  user_id: number;
}

export default class extends GridController<MadeBatch> {
  static targets = super.targets.concat("searchInput");

  declare readonly hasSearchInputTarget: boolean;

  $paymentsGrid: HTMLFormElement;
  $searchInput: HTMLInputElement;

  override connect() {
    this.$searchInput = document.querySelector(".search-input");
    this.$paymentsGrid = document.querySelector("#made-batch-payments");

    super.connect();

    const ctrl = this;
    events.subscribeOnEnter(this.$searchInput, () => ctrl.gridApi.onFilterChanged());
  }

  override buildGrid() {
    const ctrl = this;
    const { indexPath, i18nJson, paginationPageSize } = this.gridTarget.dataset;

    const colDefs: AgGrid.ColDef[] = [
      { field: "number", ...columns.NUMBER_COL_DEF, ...columns.NUMBER_FILTER_COL_DEF, sortable: true },
      { field: "user_id", ...columns.DEFAULT_COL_DEF, ...columns.TEXT_FILTER_COL_DEF, sortable: true },
      { field: "reviewer_id", ...columns.DEFAULT_COL_DEF, ...columns.TEXT_FILTER_COL_DEF, sortable: true },
      { field: "count", ...columns.NUMBER_COL_DEF, ...columns.NUMBER_FILTER_COL_DEF, sortable: true },
      { field: "amount", ...columns.AMOUNT_COL_DEF, ...columns.AMOUNT_FILTER_COL_DEF, sortable: true },
      {
        field: "created_at",
        ...columns.DATE_COL_DEF,
        ...columns.DATE_FILTER_UNTIL_NOW_COL_DEF,
        sortable: true,
        sort: "asc",
      },
      {
        field: "alfa_transmission_at",
        ...columns.DATE_COL_DEF,
        ...columns.DATE_FILTER_UNTIL_NOW_COL_DEF,
        sortable: true,
      },
    ];

    const dataSource = new datasource.Datasource({
      callbacks: {
        getSearchInput() {
          return ctrl.$searchInput.value;
        },
      },
      indexPath,
      limit: paginationPageSize,
    });

    const options: AgGrid.GridOptions<MadeBatch> = {
      ...gridUtils.DEFAULT_GRID_OPTIONS,
      // override defaults
      defaultColDef: gridUtils.DEFAULT_GRID_OPTIONS.defaultColDef,
      cacheBlockSize: parseInt(paginationPageSize),
      columnDefs: gridUtils.buildColumnDefs(colDefs, { i18n: JSON.parse(i18nJson) }),
      localeText: { ...columns.FILTER_TRANSLATIONS },
      datasource: dataSource,
      // events
      onRowClicked(event) {
        const currentUrl = new URL(window.location.href);
        const country = currentUrl.searchParams.get("country");

        ctrl.$paymentsGrid.src = http.buildLocalUrl(event.data.payments_path, {
          ...(country ? { country } : {}),
          [datasource.SEARCH_PARAM]: ctrl.$searchInput.value,
        });
      },
    };
    const gridApi = AgGrid.createGrid(this.gridTarget, options);
    dataSource.gridApi = gridApi;

    return gridApi;
  }
}
